export const API_ROUTES = {
  LOGIN: 'auth',
  ME: 'user/me',
  USER_BULK_DOWNLOAD_PREFERENCES: '/user/bulk-download-preferences',
  USER_SETTINGS: '/user/settings',
  USER_SETTINGS_APPLY: '/user/settings/apply',
  USER_SETTINGS_USER: '/user/settings/user',
  USER_SETTINGS_POLICY: '/user/settings/policy',
  USER_NOTIFICATION_SETTINGS: '/user/notification-settings',
  USER_PUBLIC_DOWNLOAD_LINK_EXPIRY: '/user/public-download-link-expiry',
  ROLES: 'role',
  USER: '/user',
  RESEND_REGISTRATION_EMAIL: '/user/resend-registration-email',
  GROUPS: 'group/',
  GROUPS_WITH_ORGS: 'group/with-organizations',
  CLIP: '/videofeed/clip',
  ACCESS: 'access',
  ACCESS_MANY: 'access/many',
  FOLDER: 'folder/',
  FOLDER_COPY_STATUS: 'folder/copy-status',
  FOLDER_ALL_CONTENT: 'folder/all-content',
  MY_FOLDER_COLLABORATORS: 'folder/collaborators',
  LIST_ARCHIVED_VIDEOFEEDS: 'folder/list-archived-videofeeds',
  LIST_ARCHIVED_FOLDERS: 'folder/list-archived-folders',
  FOLDER_RESTORE: 'folder/restore-folder',
  FOLDER_EXTENDED: 'folder/extended',
  FOLDER_ACCESS: 'folder/access',
  ORGANIZATION_HAVE_COLL_FOLDERS: 'folder/have-collaborative-folders',
  COMMENT: '/comment',
  LOGOUT: 'auth/logout',
  SUBGROUPS: 'subgroup',
  VIDEOFEED: '/videofeed',
  VIDEOFEED_ARCHIVE_ONLY: '/videofeed/archive-only',
  VIDEOFEED_RESTORE: '/videofeed/restore',
  VIDEOFEED_ARCHIVE_BACKFILL_RUN: '/videofeed/archive-backfill/run',
  VIDEOFEED_VIDEOS_AND_TYPE: '/videofeed/videos-and-type',
  VIDEOFEED_ACCESS: '/videofeed/access',
  ACCESS_CHECK: '/access/check',
  REFRESH_TOKEN: 'auth/refresh-get',
  SWITCH_ORG: 'auth/switch-org',
  ORGANIZATION: 'organization/',
  ORGANIZATION_CHILDS: 'organization/childs',
  GROUPS_SEARCH: 'group/search',
  NOTIFICATION: '/notification',
  POST_VIEW_FOLDER: 'folder/viewed',
  VIDEOFEED_MOVE: '/videofeed/move',
  VIDEOFEED_COPY: '/videofeed/copy',
  REGISTER: '/auth/self-registation',
  COMPOSER_TOPIC: '/videofeed/topic',
  CREATE_CLIP_FOR_TOPIC: '/videofeed/create-clip',
  REMOVE_CLIP_FOR_TOPIC: '/videofeed/remove-clip',
  CLIP_COMMENTS: '/videofeed/clip-comments',
  CLIPS_COMMENTS: '/videofeed/clips-comments',
  REMOVE_TOPIC: '/videofeed/remove-topic',
  REFLEX_COMPOSER: '/reflex-composer',
  REFLEX_COMPOSER_ALL_CONTENT: '/reflex-composer/all-content',
  REGENERATE_PRESIGNED_URLS: '/videofeed/regenerate-presigned-urls',
  UPLOAD_CONTENT: '/videofeed/upload',
  UPLOAD_VIDEOFEED: '/videofeed/upload',
  CREATE_COMPOSER_CLIP: '/videofeed/clip',
  VIDEOFEED_REORDER: '/videofeed/reorder',
  GET_VIEW_VIDEOFEED: 'videofeed/viewed',
  VIDEOFEED_JSON: '/videofeed/upload-json',
  FORGOT_PASSWORD: '/auth/forgot-password',
  DOWNLOAD_PERMISSON: '/download-permission',
  ORGANIZATION_USERS: 'organization/users',
  ORGANIZATION_EXCLUDE_LIST: 'organization/exclude-list',
  ORGANIZATION_HOURS_USAGE_REFRESH: 'organization/calculate-hours-usage',
  ORGANIZATION_DOWNLOAD_HOURS_USAGE_REFRESH:
    'organization/calculate-download-hours-usage',
  FOLDERS_BY_USER_ID: 'folder/find-by-user',
  LIGHTWEIGHT_FOLDERS_BY_USER_ID: 'folder/find-folders-by-user',
  STORAGE_USAGE_BY_ORG_ID: 'folder/storage-usage',
  CREATE_COMPOSER_TOPIC: '/videofeed/topic',
  RESTORE_PASSWORD: '/auth/restore-password',
  ORGANIZATION_MY_ORG: 'organization/my-org',
  UPDATE_VIDEOFEED_TITLE: '/videofeed/title',
  UPDATE_VIDEO_TITLE: '/videofeed/video-title',
  COMMENT_SEARCH_TAGS: '/comment/search-tags',
  VIDEOFEED_SEND_CLIPS: '/videofeed/send-clips',
  REFLEX_COMPOSER_CLIP: '/reflex-composer/clip',
  CONTENT_SHARED_WITH_ME: 'folder/shared-with-me',
  REFLEX_COMPOSER_JSON_DOWNLOAD: '/reflex-composer/json-download',
  CONTENT_SHARED_WITH_ME_FOLDERS_COMPOSERS: 'reflex-composer/shared-with-me-folder-composers',
  FOLDER_SHALLOW: 'folder/shallow',
  REFLEX_COMPOSER_TOPIC: '/reflex-composer/topic',
  DELETE_PROFILE_AVATAR: '/user/me/delete-avatar',
  ORGANIZATION_AVATAR: 'organization/avatar',
  NOTIFICATION_RENOTIFY: '/notification/re-notify',
  VIDEOFEED_VIDEO_PAGE: '/videofeed/video-page',
  VIDEOFEED_INFO: '/videofeed/info',
  NOTIFICATION_VIDEOFEED: '/videofeed/notification',
  DOWNLOAD_JSON: '/videofeed/json-download',
  TOPIC_UPDATE: '/videofeed/topic-update',
  TIMELINE_DOWNLOAD_AVAULT: 'videofeed/avault-download',
  COMPOSER_DOWNLOAD_AVAULT: 'reflex-composer/avault-download',
  DOWNLOAD_VIDEO: '/videofeed/download',
  APPENDED_DOWNLOAD_OPTIONS: '/videofeed/appended-download-options',
  APPENDED_DOWNLOAD_SOURCES: '/videofeed/appended-download-sources',
  APPENDED_DOWNLOAD_MERGED: '/videofeed/appended-download-merged',
  VIDEOFEED_STANDALONE: '/videofeed/standalone-data',
  ORGANIZATION_REMOVE_USER: 'organization/remove-user',
  ORGANIZATION_REMOVE_USER_DELETE_IMPACT: 'organization/remove-user',
  REMOVE_USER_FULLY: 'organization/remove-user-fully',
  VIDEOFEED_VIDEO_DOWNLOAD: '/videofeed/video-download',
  VIDEOFEED_VIDEO_COMMENTS: '/videofeed/video-comments',
  VIDEOFEED_VIDEO_TIMELINE: '/videofeed/video-timeline',
  VIDEOFEED_CLOUDFRONT_COOKIES: '/videofeed/cloudfront-cookies',
  VIDEOFEED_REFRESH_STATUS: '/videofeed/refresh-status',
  VIDEOFEED_UPLOAD_CHUNK: 'videofeed/upload-video-part',
  VIDEOFEED_SHARED_WITH_ME: '/videofeed/shared-with-me',
  VIDEOFEED_FOLDER_CONTENTS: '/videofeed/folder-contents',
  VIDEOFEED_GLOBAL_SEARCH: '/videofeed/search/global',
  VIDEOFEED_UPLOAD_METADATA: 'videofeed/upload-metadata',
  VIDEOFEED_UPLOAD_ADDITIONAL_ANGLE: '/videofeed/upload-additional-angle',
  VIDEOFEED_COMPLETE_ADDITIONAL_ANGLE_UPLOAD: '/videofeed/complete-additional-angle-upload',
  VIDEOFEED_CANCEL_ADDITIONAL_ANGLE_UPLOAD: '/videofeed/cancel-additional-angle-upload',
  VIDEOFEED_UPLOAD_JSON: 'videofeed/upload-json-direct',
  MERGE_SESSION: '/merge-session',
  ORGANIZATION_VIDEOFEED_CSV: 'videofeed/org-transcoded-csv/',
  ORGANIZATION_EXTERNAL_SHARE_EMAILS_CSV: 'organization/external-share-emails-csv/',
  REFLEX_COMPOSER_ADD_TOPICS: '/reflex-composer/add-topics',
  ALL_CONTENT: '/reflex-composer/all-content',
  ORGANIZATION_UPLOAD_AVATAR: '/organization/my-org/avatar',
  REFLEX_COMPOSER_SHARED_WITH_ME: '/reflex-composer/shared-with-me',
  VIDEOFEED_CREATE_MULTIPART_UPLOAD: 'videofeed/create-multipart-upload',
  VIDEOFEED_COMPLETE_MULTIPART_UPLOAD_CHUNKS: 'videofeed/complete-video-uploading-chunks',
  CREATE_SUPER_ADMIN: '/user/create-super-admin',
  GET_PREVIEW_ACCESS_TOKEN: '/user/user-preview',
  REVOKE_SUPER_ADMIN: '/user/revoke-super-admin',
  POST_USER_REQUEST_HELP: '/user/request-user-help',
  POST_USER_HELP_RESPONSE: '/user/user-help-response',
  GET_USERS_BY_EMAIL_ARRAY: '/user/emails',
  ALL_CONTENT_VIDEOFEEDS: 'videofeed/all-content-videofeeds',
  COLLABORATIVE_FOLDER: '/folder/collaborative-folders',
  COLLABORATIVE_FOLDER_FOR_PARENT: '/folder/collaborative-folders/parent',
  MY_COLLABORATIVE_FOLDER: '/folder/my-collaborative-folder',
  VIDEOFEED_SHARED_CHECK: 'videofeed/shared/check',
  VIDEOFEED_EXTERNAL_SHARES: '/external-shares',
  PINNED_CONTENT: '/pinned-content',
};
